<era-master-detail flexGrowLeft="1"
                   flexGrowRight="2"
                   [isH2]="false">
  <era-master>
    <ml-mdm-settings-profile-preset-list [presets]="presets | async"
                                         [profileType]="profileType"
                                         [headerLabel]="headerLabel"
                                         (deletePreset)="deletePreset($event)"></ml-mdm-settings-profile-preset-list>
  </era-master>
</era-master-detail>